import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent, ConfigurationService, LoggerService, SecurityService } from 'saker-core';
import { ProjectService } from 'src/app/Service/project.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseComponent implements OnInit {

  // -----------------------------------
  // Model
  // -----------------------------------

  projects: any[] = [];

  // -----------------------------------
  // Behaviour
  // -----------------------------------

  show(mnemonic: string) {
    this.router.navigate(['/projectScenarios/' + mnemonic])
  }

  // -----------------------------------
  // Private
  // -----------------------------------

  private getProjects() {

    return this.projectService.getProjects()
      .subscribe((data:any) => {
        this.projects = data;
        return this.projects;
      });

  }

  //-------------------------------
  // Form
  //-------------------------------

  //-------------------------------
  // System
  //-------------------------------

  private activate() {

    this.getProjects();

  }
  
  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private projectService: ProjectService
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  ngOnInit(): void {
    this.activate()
  }


}
